import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UtilsBsHotToastService } from '@brunsker/libs/core/utils/hot-toast/src';
import { LoginResponse, MapperService, SelectClientService } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';
import { take } from 'rxjs';
import { NewApiUserService } from '../../../api/new-api-user/new-api-user.service';
import { NewApiClienteService } from '../../../api/new-api-cliente/new-api-cliente.service';
import { CookiesService } from '@brunsker/libs/core/utils/cookies/src';

@Injectable({
  providedIn: 'root',
})
export class HomeDomainService {
  user!: LoginResponse;
  loading!: boolean;
  hasClient$$ = this.selectClientService.hasClient$$;

  constructor(
    private readonly toastService: UtilsBsHotToastService,
    private readonly selectClientService: SelectClientService,
    readonly newApiUserService: NewApiUserService,
    readonly newApiClienteService: NewApiClienteService,
    readonly router: Router,
    readonly cookies: CookiesService,
    readonly mapperService: MapperService
  ) {
    this.newApiClienteService
      .getClienteForOptions('')
      .pipe(take(1))
      .subscribe(() => {
        this.mapperService.hasLoading$.next(true);
      });

  }

  start(): void {
    this.newApiUserService.currentUser$$.subscribe((user: any) => {
      if (user) {
        this.user = user;
      }
    });
  }

  logoff() {
    this.newApiUserService.logoff();
    this.toastService.showWarning('Logoff...');
    this.cookies.deleteCookie('password');
    this.router.navigateByUrl('/auth');
  }

  openDialog(dialogToken: MatDialogRef<any>): void {
    this.newApiClienteService
      .getClientes({ length: 30, index: 0 })
      .subscribe((_clientes: any) => {
        dialogToken;
      });
  }

  openFutureDialog(dialogToken: MatDialogRef<any>): void {
    this.newApiClienteService
      .getClientes({ length: 30, index: 0 })
      .subscribe((_clientes: any) => {
        dialogToken;
      });
  }
}
